// import { enableProdMode, importProvidersFrom } from '@angular/core';
// import { bootstrapApplication } from '@angular/platform-browser';
// import { RouteReuseStrategy, provideRouter } from '@angular/router';
// import { IonicRouteStrategy, provideIonicAngular } from '@ionic/angular/standalone';

// import { Capacitor } from '@capacitor/core';
// import { routes } from './app/app.routes';
// import { AppComponent } from './app/app.component';
// import { environment } from './environments/environment';
// import { provideHttpClient } from '@angular/common/http';

// import { initializeApp, provideFirebaseApp,getApp } from '@angular/fire/app';
// import { getAuth, provideAuth, initializeAuth, indexedDBLocalPersistence } from '@angular/fire/auth';

// import { getAnalytics, provideAnalytics, ScreenTrackingService, UserTrackingService } from '@angular/fire/analytics';
// import { getFirestore, provideFirestore } from '@angular/fire/firestore';
// import { getMessaging, provideMessaging,onMessage } from '@angular/fire/messaging';
// import { getStorage, provideStorage } from '@angular/fire/storage';


// import { defineCustomElements } from '@ionic/pwa-elements/loader';

// defineCustomElements(window);
// if (environment.production) {
//   enableProdMode();
// }

// bootstrapApplication(AppComponent, {
//   providers: [
//     { provide: RouteReuseStrategy, useClass: IonicRouteStrategy },
//     provideIonicAngular(),
//     provideRouter(routes), 
//     provideHttpClient(),
//     importProvidersFrom(provideFirebaseApp(
//       () => initializeApp(
//         environment.firebaseConfig
//         ))), 
//     importProvidersFrom(provideAuth(() => getAuth())), 
//     importProvidersFrom(provideAnalytics(() => getAnalytics())), 
//     ScreenTrackingService, 
//     UserTrackingService, 
//     importProvidersFrom(provideFirestore(() => getFirestore())), 
//     importProvidersFrom(provideMessaging(() => getMessaging())), 
//     importProvidersFrom(provideStorage(() => getStorage())),
//     importProvidersFrom(
//       provideAuth(() => {
//         if(Capacitor.isNativePlatform()){
//           return initializeAuth(getApp(),{
//             persistence: indexedDBLocalPersistence
//           })
//         } else {
//           return getAuth()
//         }

//       }
//     ),
//     ),
//   ],
// });


import { enableProdMode } from '@angular/core';
import { bootstrapApplication } from '@angular/platform-browser';
import { RouteReuseStrategy, provideRouter } from '@angular/router';
import { IonicRouteStrategy, provideIonicAngular } from '@ionic/angular/standalone';

import { Capacitor } from '@capacitor/core';
import { routes } from './app/app.routes';
import { AppComponent } from './app/app.component';
import { environment } from './environments/environment';
import { provideHttpClient } from '@angular/common/http';

import { initializeApp, provideFirebaseApp, getApp } from '@angular/fire/app';
import { getAuth, provideAuth, initializeAuth, indexedDBLocalPersistence } from '@angular/fire/auth';
import { getAnalytics, provideAnalytics, ScreenTrackingService, UserTrackingService } from '@angular/fire/analytics';
import { getFirestore, provideFirestore } from '@angular/fire/firestore';
import { getMessaging, provideMessaging } from '@angular/fire/messaging';
import { getStorage, provideStorage } from '@angular/fire/storage';

import { defineCustomElements } from '@ionic/pwa-elements/loader';

defineCustomElements(window);
if (environment.production) {
  enableProdMode();
}

bootstrapApplication(AppComponent, {
  providers: [
    { provide: RouteReuseStrategy, useClass: IonicRouteStrategy },
    provideIonicAngular(),
    provideRouter(routes),
    provideHttpClient(),

    // ✅ No need for `importProvidersFrom()` here
    provideFirebaseApp(() => initializeApp(environment.firebaseConfig)),
    provideAuth(() => getAuth()),
    provideAnalytics(() => getAnalytics()),
    provideFirestore(() => getFirestore()),
    provideMessaging(() => getMessaging()),
    provideStorage(() => getStorage()),

    // ✅ Fix for Native Auth Initialization
    provideAuth(() => {
      if (Capacitor.isNativePlatform()) {
        return initializeAuth(getApp(), {
          persistence: indexedDBLocalPersistence,
        });
      } else {
        return getAuth();
      }
    }),

    ScreenTrackingService,
    UserTrackingService,
  ],
});
